import { Component, OnInit } from '@angular/core';
import {CompanyService} from '../../services/company.service';
import {PartnerCounterService} from '../../services/partner-counter.service';
import {Company} from '../../../dto/company';
import {PartnerInvoice} from '../../../dto/partnerCounter';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-partner-counter-index',
  templateUrl: './partner-counter-index.component.html',
  styleUrls: ['./partner-counter-index.component.css']
})
export class PartnerCounterIndexComponent implements OnInit {


  constructor(
    private companiesService: CompanyService,
    private partnerCounterService: PartnerCounterService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  companies: Company[];
  invoices: PartnerInvoice[];
  isLoadingCompanies = false;
  isLoadingInvoices = false;
  displayedColumns = ['edit', 'invoiceNumber', 'invoiceDate', 'company', 'netTotal', 'commissionNetTotal', 'finished', 'paid'];

  ngOnInit(): void {
    this.loadCompanies();
  }

  private loadCompanies() {
    this.isLoadingCompanies = true;
    this.companiesService.getAll().subscribe(x => {
      this.companies = x.data;
      this.companies.forEach((company) => {
        company.logoUrl = company.logoFileName ? environment.apiUrl + company.logoFileName : null;
      });
      this.isLoadingCompanies = false;
      this.loadInvoices();
    });
  }

  private loadInvoices() {
    this.isLoadingInvoices = true;
    this.partnerCounterService.getInvoices().subscribe(x => {
      this.invoices = x;
      this.isLoadingInvoices = false;
    });
  }

  editInvoice(invoiceId: number, companyId: number) {
    this.router.navigate([companyId, 'invoice', invoiceId], {
      relativeTo: this.route
    });
  }
}
